export const createSeededRandom = (seed) => {
  let state = Math.abs(Number(seed) || 1) % 2147483647;
  if (state === 0) {
    state = 1;
  }

  return () => {
    state = (state * 16807) % 2147483647;
    return (state - 1) / 2147483646;
  };
};
